import type { AdminPageAccessRule } from '../../registry.ts';

/** Хто бачить сторінку `model`: у перший екран їде лише це (опис і код — у `page.ts`). */
export default {
  group: 'model',
  permission: 'metadata.read',
} satisfies AdminPageAccessRule;
